import { ElementSelection } from "../BaseElementEditor";

const DebugBoxSelection = ElementSelection.extend({
});

export const editors = {
    DebugBoxSelection,
};
